export const baseUrl = () => {
  return process.env.REACT_APP_NTTS_BACKEND_BASE_URL
}
